import React from 'react';
import { CheckIcon, RefreshCwIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
const includes = ['6 Tomos Premium', 'Mapas de Ritual por Producto', 'Worksheets de Implementación', 'Checklists Accionables', 'Banco de Fórmulas Aromáticas'];
const freeBonuses = ['Bono #1 — 120 Nombres Premium', 'Bono #2 — 24 Tarjetas de Ritual Imprimibles', 'Bono #3 — Checklist de Marca Premium', 'Bono #4 — Diccionario Sensorial para Vender Aromas', 'Bono #5 — Planner de Colecciones Aromáticas'];
export function Offer() {
  return <section className="w-full bg-[#2a2438] px-5 py-14 text-white" data-id="element-156" data-mp="13uof8mxgztbt">
      <div className="mx-auto max-w-md" data-id="element-157" data-mp="ywd5ec76ditl">
        <h2 className="text-center font-serif-display text-3xl font-bold leading-tight" data-id="element-158" data-mp="2fc698up91el5">
          Todo lo que recibirás hoy
        </h2>

        <div className="mt-8 rounded-2xl bg-white/5 p-5 ring-1 ring-white/10" data-id="element-159" data-mp="2ac1tx802upwi">
          <h3 className="font-serif-display text-lg font-semibold text-[#c9b8ea]" data-id="element-160" data-mp="pkqnq9livt9r">
            Biblioteca de Rituales Aromáticos™
          </h3>
          <ul className="mt-3 space-y-2" data-id="element-161" data-mp="uhh2mtllcitl">
            {includes.map(i => <li key={i} className="flex items-center gap-2 text-sm text-white/85" data-id="element-162" data-mp="zjpwds6afowr">
                <CheckIcon className="w-4 h-4 shrink-0 text-[#c9b8ea]" data-id="element-163" data-mp="13iyqiy58posu" />
                {i}
              </li>)}
          </ul>

          <div className="my-5 h-px w-full bg-white/10" data-id="element-164" data-mp="6rmqke93iyae" />

          <h3 className="font-serif-display text-lg font-semibold text-[#e6d3ae]" data-id="element-165" data-mp="btvn1kl6gih9">
            Además recibirás GRATIS
          </h3>
          <ul className="mt-3 space-y-2" data-id="element-166" data-mp="ft4fmm4heab8">
            {freeBonuses.map(i => <li key={i} className="flex items-center gap-2 text-sm text-white/85" data-id="element-167" data-mp="kmp3vmg9vpx8">
                <CheckIcon className="w-4 h-4 shrink-0 text-[#6f9160]" data-id="element-168" data-mp="3k7km0eooswfk" />
                {i}
              </li>)}
          </ul>
        </div>

        {/* Value stack */}
        <div className="mt-6 rounded-2xl bg-white p-6 text-[#2a2438]" data-id="element-169" data-mp="vez0anxon90c">
          <div className="space-y-2 text-sm" data-id="element-170" data-mp="qgnrmgj4j4jp">
            <div className="flex items-center justify-between" data-id="element-171" data-mp="qfurvzil1fb2">
              <span className="text-[#5a5266]" data-id="element-172" data-mp="155agb8un58nl">Biblioteca de Rituales Aromáticos™</span>
              <span className="font-semibold text-[#8a8296] line-through" data-id="element-173" data-mp="106gzb6g5azio">$67 USD</span>
            </div>
            <div className="flex items-center justify-between" data-id="element-174" data-mp="cgmp6wn7np24">
              <span className="text-[#5a5266]" data-id="element-175" data-mp="ch4s2c4dp1j0">5 Bonos Exclusivos</span>
              <span className="font-semibold text-[#8a8296] line-through" data-id="element-176" data-mp="7j3ci165vkca">$95 USD</span>
            </div>
          </div>
          <div className="my-4 h-px w-full bg-[#e4dbcc]" data-id="element-177" data-mp="livyxkanneeg" />
          <div className="flex items-center justify-between" data-id="element-178" data-mp="hfpvsliua3c7">
            <span className="font-semibold text-[#3b3350]" data-id="element-179" data-mp="hic2kixwoetd">Valor total</span>
            <span className="font-serif-display text-xl font-bold text-[#8a8296] line-through" data-id="element-180" data-mp="1wuwtjfu79x24">$162 USD</span>
          </div>

          <div className="mt-5 rounded-2xl bg-[#efe7da] p-5 text-center" data-id="element-181" data-mp="20enhmc6z3int">
            <p className="text-xs font-semibold uppercase tracking-widest text-[#7c6aa8]" data-id="element-182" data-mp="20dce8dhfwcx8">
              Hoy puedes acceder por solo
            </p>
            <p className="my-1 font-serif-display text-5xl font-bold text-[#3b3350]" data-id="element-183" data-mp="1qgzjrde2lv1f">$12.99 USD</p>
            <p className="mb-4 flex items-center justify-center gap-1.5 text-xs text-[#7a7288]" data-id="element-184" data-mp="1vf14e2r5a2f0">
              <RefreshCwIcon className="w-3.5 h-3.5 text-[#7c6aa8]" data-id="element-185" data-mp="2j4lqguilhfsi" />
              El cambio de moneda es automático a tu país
            </p>

            <div className="mb-5" data-id="element-186" data-mp="2o3ghgjqpuanp">
              <ScarcityBar data-id="element-187" data-mp="29fbz5gvks15g" />
            </div>

            <CTAButton label="Sí, quiero mi Biblioteca ahora" data-id="element-188" data-mp="29ekcivjyhdrb" />

            <div className="mt-4" data-id="element-189" data-mp="2edwwn8jg06q7">
              <p className="mb-2 text-[11px] font-semibold uppercase tracking-widest text-[#7c6aa8]" data-id="element-190" data-mp="2ed3wiqezofh1">
                Esta oferta termina en
              </p>
              <Countdown data-id="element-191" data-mp="36ug3bc2wz4cr" />
            </div>

            <div className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-medium text-[#7a7288]" data-id="element-192" data-mp="36wakcfb2ecbk">
              <span data-id="element-193" data-mp="1j4bgtgs1zzj0">✔ Pago único</span>
              <span data-id="element-194" data-mp="1e6s2yhz9porl">✔ Acceso de por vida</span>
              <span data-id="element-195" data-mp="1e607r89l1t1u">✔ Descarga inmediata</span>
              <span data-id="element-196" data-mp="197ovkqvtf6gg">✔ Sin suscripciones</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}